import { SURPORT_MODELS } from "@/constants";
import { checkUpgrate } from "@/utils/window";
import { create } from "zustand";

interface AppState {
  isSupportFullScreen: boolean;
  isSupportMaximize: boolean;
  isSupportExport: boolean;
  isFullScreen: boolean;
  isMaximize: boolean;
  isDarkMode: boolean;
  asrModelId: string;
  hasUpdate: boolean;
  newVersion: string;
  currentVersion: string;
}

interface AppStore extends AppState {
  toggleDarkMode: () => void;
  setIsSupportFullScreen: (isSupportFullScreen: boolean) => void;
  setIsSupportMaximize: (isSupportMaximize: boolean) => void;
  setIsSupportExport: (isSupportExport: boolean) => void;
  checkUpgrate: () => void;
  setCurrentVersion: (currentVersion: string) => void;
}

const appState: AppState = {
  isSupportFullScreen: false,
  isSupportMaximize: false,
  isSupportExport: false,
  isFullScreen: false,
  isMaximize: false,
  isDarkMode: false,
  asrModelId: SURPORT_MODELS[0].id,
  hasUpdate: false,
  newVersion: "",
  currentVersion: "",
};

const appStore = create<AppStore>()((set, get) => ({
  ...appState,
  toggleDarkMode: () => {
    const isDarkMode = get().isDarkMode;
    console.log("isDarkMode", isDarkMode);
    set((state) => ({ isDarkMode: !state.isDarkMode }));
  },
  setIsSupportFullScreen: (isSupportFullScreen) => {
    set({ isSupportFullScreen });
  },
  setIsSupportMaximize: (isSupportMaximize) => {
    set({ isSupportMaximize });
  },
  setIsSupportExport: (isSupportExport) => {
    set({ isSupportExport });
  },
  checkUpgrate: async () => {
    try {
      console.log("checkUpgrate");
      const res = await checkUpgrate();
      const targetVersion = res?.targetVersionCode || res?.versionCode;
      console.log('checkUpgrate new version', targetVersion);
      set({ hasUpdate: res.hasUpdate, newVersion: targetVersion });
    } catch (e) {
      console.error("check upgrate error", e);
    }
  },
  setCurrentVersion: (currentVersion) => {
    set({ currentVersion });
  },
}));

// app 启动的时候先检查一下是否有更新
appStore.getState().checkUpgrate();

export default appStore;
